
type Predicate<T> = (item: T) => boolean

export function* first<T>(items: Iterable<T>, params: { count?: number, predicate?: Predicate<T> }): Generator<T>
{
    const count = params.count || 1;
    const predicate = params.predicate || (() => true);
    let yielded = 0;
    for (const item of items)
    {
        if (yielded >= count) { break; }
        if (predicate(item))
        {
            yield item;
            yielded++;
        }
    }
}

export function* filter<T>(items: Iterable<T>, predicate: Predicate<T>): Generator<T>
{
    for (const item of items)
    {
        if (predicate(item))
        {
            yield item;
        }
    }
}

export function* concat<T>(...iterables: Iterable<T>[]): Generator<T>
{
    for (const iterable of iterables)
    {
        for (const item of iterable)
        {
            yield item;
        }
    }
}